const commonPasswords = new Set([
  '000000',
  '00000000',
  '111111',
  '11111111',
  '123123',
  '123321',
  '123456',
  '1234567',
  '12345678',
  '123456789',
  '1234567890',
  '987654321',
  'abc123',
  'abcdefgh',
  'admin',
  'admin123',
  'administrator',
  'asdfgh',
  'dragon',
  'football',
  'iloveyou',
  'letmein',
  'monkey',
  'password',
  'password1',
  'password123',
  'qwerty',
  'qwerty123',
  'qwertyuiop',
  'senha',
  'senha1',
  'senha123',
  'senha1234',
  'senhafacil',
  'test',
  'test123',
  'teste123',
  'welcome',
  'zxcvbnm',
]);

function compactPassword(password: string, replaceLeetCharacters = false): string {
  let value = password.normalize('NFKC').trim().toLocaleLowerCase();

  if (replaceLeetCharacters) {
    value = value
      .replace(/@/g, 'a')
      .replace(/\$/g, 's')
      .replace(/0/g, 'o')
      .replace(/1/g, 'i')
      .replace(/3/g, 'e')
      .replace(/4/g, 'a')
      .replace(/5/g, 's')
      .replace(/7/g, 't');
  }

  return value.replace(/[^\p{L}\p{N}]+/gu, '');
}

function hasNumericSequence(password: string): boolean {
  const numericRuns = password.match(/\d{4,}/g) ?? [];

  return numericRuns.some(run => {
    let direction: number | null = null;
    let sequenceLength = 1;

    for (let index = 1; index < run.length; index += 1) {
      const difference = Number(run[index]) - Number(run[index - 1]);

      if ((difference === 1 || difference === -1) && (direction === null || difference === direction)) {
        direction ??= difference;
        sequenceLength += 1;
      } else {
        direction = null;
        sequenceLength = 1;
      }

      if (sequenceLength >= 4) return true;
    }

    return false;
  });
}

/**
 * Mirrors the API password policy to provide immediate feedback before a
 * password is submitted. The backend remains the source of enforcement.
 */
export function isWeakPassword(password: string): boolean {
  const compact = compactPassword(password);
  const leetNormalized = compactPassword(password, true);

  return (
    commonPasswords.has(compact) ||
    commonPasswords.has(leetNormalized) ||
    hasNumericSequence(password) ||
    /^(.)\1{3,}$/u.test(compact)
  );
}
